import { render, staticRenderFns } from "./simulation-item.vue?vue&type=template&id=10de02c4&scoped=true&"
import script from "./simulation-item.vue?vue&type=script&lang=ts&"
export * from "./simulation-item.vue?vue&type=script&lang=ts&"
import style0 from "./simulation-item.vue?vue&type=style&index=0&id=10de02c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de02c4",
  null
  
)

export default component.exports